import _ from 'lodash'
import colors from 'quasar/src/utils/colors.js';
import { BloodUnit } from '@/lib/enums'

export function setThemeColor (color, value, element = document.body) {
  if (typeof color !== 'string') {
    throw new TypeError('Expected a string as color')
  }
  if (typeof value !== 'string') {
    throw new TypeError('Expected a string as value')
  }
  if (!(element instanceof Element)) {
    throw new TypeError('Expected a DOM element')
  }
  const kebabCaseColor = _.kebabCase(color)
  if (!kebabCaseColor.includes('-')) {
    colors.setBrand(color, value, element)
  }
  element.style.setProperty(`--i-color-${kebabCaseColor}`, value)
}

export function getThemeColor (color, element = document.body) {
  if (typeof color !== 'string') {
    throw new TypeError('Expected a string as color')
  }
  if (!(element instanceof Element)) {
    throw new TypeError('Expected a DOM element')
  }
  const kebabCaseColor = _.kebabCase(color)
  if (!kebabCaseColor.includes('-')) {
    return colors.getBrand(color, element)
  }
  return getComputedStyle(element).getPropertyValue(`--i-color-${kebabCaseColor}`).trim() || null
}

export function computeColorValue (color) {
  if (/#|\(/.test(color)) return color
  return colors.getPaletteColor(color)
}

export function unitShowType (unit, isCount) {
  const str = []
  let count = 0
  // 计算总数
  if (isCount) {
    for (const key in unit) {
      count += Number(unit[key])
    }
    return count
  } else {
    // 按单位分类计算
    for (const key in unit) {
      // 精确血量到小数点后一位
      const unitNumber = ((unit[key] * (10 ** 1)) << 0) / (10 ** 1)
      str.push(`${unitNumber}${BloodUnit.getItemText(key.split('-')[1])}`)
    }
    return str.join('+')
  }
}

export function pivot (rows, groupings, selectors, noSummary) {
  if (!rows?.length) return
  if (!(groupings instanceof Array)) throw new Error('参数groupings不是数组')
  if (!(selectors instanceof Array)) throw new Error('参数selectors不是数组')
  groupings = groupings.map(field => _.isString(field) ? ({
    name: field,
    value: row => row[field]
  }) : field)
  const groups = _.groupBy(rows, row => JSON.stringify(groupings.map(col => col.value(row))))
  const result = []
  const extPivots = new Array(selectors.length)
  for (let index = 0; index < selectors.length; index++) {
    const pivot = selectors[index]
    const extPivot = {}
    extPivots[index] = extPivot
    if (pivot.reduce instanceof Function) {
      extPivot.reduce = pivot.reduce
    } else {
      const builtinReduces = {
        sum: function (accumulator, currRow) {
          accumulator[pivot.name] += currRow[pivot.name]
          return accumulator
        },
        first: function (accumulator, currRow) {
          console.log(currRow[pivot.name])
          accumulator[pivot.name] = currRow[pivot.name]
          return accumulator
        }
      }
      extPivot.reduce = builtinReduces[pivot.reduce] ?? builtinReduces.sum
    }
  }
  for (const key in groups) {
    if (!Object.hasOwnProperty.call(groups, key)) {
      continue
    }
    const group = Object.freeze(groups[key])
    const spreadGroup = []
    for (let i1 = 0; i1 < group.length; i1++) {
      const row = group[i1]
      const spreadRow = {}
      for (let i2 = 0; i2 < groupings.length; i2++) {
        const gbCol = groupings[i2]
        spreadRow[gbCol.name] = gbCol.value(row)
      }
      for (let i2 = 0; i2 < selectors.length; i2++) {
        const pivot = selectors[i2]
        spreadRow[pivot.name] = pivot.value instanceof Function ? pivot.value(row) : pivot.value
      }
      spreadGroup.push(spreadRow)
    }
    const accumulator = spreadGroup.reduce(function (accumulator, currSpreadRow, currIndex, array) {
      for (let index = 0; index < extPivots.length; index++) {
        const extPivot = extPivots[index]
        extPivot.reduce(accumulator, currSpreadRow, currIndex, array)
      }
      return accumulator
    })
    if (accumulator) {
      for (const key in accumulator) {
        if (typeof accumulator[key] === 'number') {
          accumulator[key] = ((accumulator[key] * (10 ** 1)) << 0) / (10 ** 1)
        }
      }
      result.push(accumulator)
    }
  }
  if (!noSummary && result.length) {
    // 获取所有单位并去重变对象
    const units = _.keyBy(_.uniq(_.map(result, 'unit')))
    /**
     * 没有单位的 直接计算总和
    */
    if (Object.keys(units).includes('undefined')) {
      const summary = Object.assign({}, result[0])
      for (let i1 = 1; i1 < result.length; i1++) {
        const item = result[i1]
        for (let i2 = 0; i2 < extPivots.length; i2++) {
          const extPivot = extPivots[i2]
          extPivot.reduce(summary, item, i1, result)
        }
      }
      summary[groupings[0].name] = '总计'
      for (let i1 = 1; i1 < groupings.length; i1++) {
        summary[groupings[i1].name] = null
      }
      result.push(summary)
    } else {
      /**
       * 有单位的 需按单位分类计算总和
      */
      // const summary = Object.assign({}, result[0])
      // const units = _.keyBy(_.uniq(_.map(result, 'unit')))
      // 数据按单位分类
      const resultUnitItem = _.groupBy(result, 'unit')
      // ------------
      const unitArr = _.keyBy(_.uniq(_.map(result, 'unit')))
      for (const key in unitArr) {
        unitArr[key] = Object.assign({}, result[0])
        for (const unitKey in unitArr[key]) {
          if (!(_.map(groupings, 'name').includes(unitKey))) {
            unitArr[key][unitKey] = ((_.sumBy(resultUnitItem[key], unitKey) * (10 ** 1)) << 0) / (10 ** 1)
            unitArr[key].componentId = ''
            unitArr[key].totalCount = `${_.sumBy(result, 'totalCount')}`
            unitArr[Object.keys(unitArr)[0]].componentId = '总计'
            unitArr[key].unit = BloodUnit.getItemText(key)
            unitArr[key].rh = ''
          }
        }
        result.push(unitArr[key])
      }
      for (const key in unitArr) {
        if (Object.keys(unitArr)[0] !== key) {
          unitArr[key].totalCount = ''
        }
      }
      // ---------
      // selectors.forEach((item, index) => {
      //   item.units = units
      //   // 加上 单位分类
      //   for (const unitItemKey in item.units) {
      //     item[`${item.name}-${unitItemKey}`] = _.sumBy(resultUnitItem[unitItemKey], item.name)
      //   }
      //   //
      //   for (const key in summary) {
      //     if (item.name === key) {
      //       const okKeys = Object.keys(item).filter(i => i.includes(key))
      //       summary[key] = _.pick(item, okKeys)
      //       if (Object.keys(summary[key]).find(i => i.includes('Count'))) {
      //         summary[key] = unitShowType(summary[key], true)
      //       } else {
      //         summary[key] = unitShowType(summary[key])
      //       }
      //     }
      //   }
      // })
      // summary[groupings[0].name] = '总计'
      // summary.unit = _.uniq(_.map(result, 'unit')).map(i => BloodUnit.getItemText(i)).join('+')
      // // summary[groupings[1].name] = '总计'
      // result.push(summary)
    }
  }
  return result
}

export function pivotSummary (data, groupings) {
  if (!(data instanceof Array)) throw new Error('参数data不是数组')
  if (!(groupings instanceof Array)) throw new Error('参数groupings不是数组')
  if (data && data.length < 1) {
    return
  }
  const units = _.keyBy(_.uniq(_.map(data, 'unit')))
  const selectors = []
  const summary = Object.assign({}, data[0])
  /**
     * 没有单位的 直接计算总和
  */
  if (Object.keys(units).includes('undefined')) {
    Object.keys(summary).forEach((item, index) => {
      if (!groupings.includes(item)) {
        selectors.push(item)
      }
    })
    for (const key in summary) {
      summary[key] = null
      if (selectors.includes(key)) {
        summary[key] = _.sumBy(data, key)
      }
    }
    summary.componentId = '总计'
    summary.unit = data[0]?.unit ?? ''
    return summary
  } else {
    /**
     * 有单位的 需按单位分类计算总和
    */
    // 1、---- 总计：按单位多行展示
    const resultUnitItem = _.groupBy(data, 'unit')
    const unitArr = _.keyBy(_.uniq(_.map(data, 'unit')))
    for (const key in unitArr) {
      unitArr[key] = Object.assign({}, data[0])
      for (const unitKey in unitArr[key]) {
        if (!(_.map(groupings, 'name').includes(unitKey))) {
          unitArr[key][unitKey] = ((_.sumBy(resultUnitItem[key], unitKey) * (10 ** 1)) << 0) / (10 ** 1)
          unitArr[key].componentId = ''
          unitArr[key].count = `${_.sumBy(data, 'count')}`
          unitArr[Object.keys(unitArr)[0]].componentId = '总计'
          unitArr[key].unit = BloodUnit.getItemText(key)
          unitArr[key].rh = ''
        }
      }
      data.push(unitArr[key])
    }
    for (const key in unitArr) {
      if (Object.keys(unitArr)[0] !== key) {
        unitArr[key].count = ''
      }
    }
    return data
    // 2、---- 总计在一行展示
    // const resultUnitItem = _.groupBy(data, 'unit')
    // Object.keys(summary).forEach((item, index) => {
    //   if (!groupings.includes(item)) {
    //     selectors.push({ text: item })
    //   }
    // })
    // selectors.forEach((item, index) => {
    //   item.units = units
    //   for (const unitItemKey in item.units) {
    //     item[`${item.text}-${unitItemKey}`] = _.sumBy(resultUnitItem[unitItemKey], item.text)
    //   }
    //   //
    //   for (const key in summary) {
    //     if (item.text === key) {
    //       const okKeys = Object.keys(item).filter(i => i.includes(key))
    //       summary[key] = _.pick(item, okKeys)
    //       // 不区分大小写情况- 判断是否需要添加单位展示 capacity
    //       const patt = new RegExp('capacity', 'i')
    //       if (Object.keys(summary[key]).find(i => patt.test(i))) {
    //         summary[key] = unitShowType(summary[key])
    //       } else {
    //         summary[key] = unitShowType(summary[key], true)
    //       }
    //     }
    //   }
    // })
    // //
    // summary.unit = _.uniq(_.map(data, 'unit')).map(i => BloodUnit.getItemText(i)).join('+')
    // summary.componentId = '总计'
    // return summary
    // --------
  }
}
